'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TableRow", {
    enumerable: true,
    get: function() {
        return TableRow;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useTableRow = require("./useTableRow");
const _renderTableRow = require("./renderTableRow");
const _useTableRowStylesstyles = require("./useTableRowStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const TableRow = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useTableRow.useTableRow_unstable)(props, ref);
    (0, _useTableRowStylesstyles.useTableRowStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useTableRowStyles_unstable')(state);
    return (0, _renderTableRow.renderTableRow_unstable)(state);
});
TableRow.displayName = 'TableRow';
